<template>
  <div id="app">
    <navigation>
      <router-view />
    </navigation>
  </div>
</template>
<script>

  export default {
    name:'app',
    mounted(){

    }
  }
</script>
<style lang="less">
@import "assets/public.css";
</style>
